export default __webpack_public_path__ + "static/layout-example-sideNav-light-e2e5892cd07ca7e95723b0ef39a4dc05.png";